import { Box, Typography } from '@mui/material';

/** Text-only empty state — avoids icon/image overlays that can look broken in the grid. */
export default function AdminGridEmpty({
  title = 'No data found',
  subtitle = 'Nothing matches this view yet',
}: {
  title?: string;
  subtitle?: string;
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        height: '100%',
        minHeight: 220,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 4,
        textAlign: 'center',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h6" fontWeight={800} color="text.primary">
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 440, fontWeight: 600 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
